
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/b", function() {
      var page = require("private-next-pages/b.js")
      if(module.hot) {
        module.hot.accept("private-next-pages/b.js", function() {
          if(!next.router.components["/b"]) return
          var updatedPage = require("private-next-pages/b.js")
          next.router.update("/b", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  